import axios from '@/utils/axios'
// 列表
export function listBook(query) {
    return axios({
        url: '/booklist/getBookList',
        method: 'get',
        params: query
    })
}
export function details(query) {
    return axios({
        url: '/novelStrategy/getIListById',
        method: 'get',
        params: query
    })
}
// 添加图书
export function addBook(query) {
    return axios({
        url: '/novelStrategy/addStrategy',
        method: 'post',
        data: query
    })
}
// 删除
export function del(query) {
    return axios({
        url: '/novelStrategy/deleteClientditch',
        method: 'post',
        params: query
    })
}
// 目录
export function catalog(query) {
    return axios({
        url: '/novel/ditchbookchapter/getCatalogue',
        method: 'get',
        params: query
    })
}
// 章节内容
export function content(query) {
    return axios({
        url: '/novel/ditchbookchapter/getChapterContent',
        method: 'get',
        params: query
    })
}
// 未分销的书
export function bookListDistribution(query) {
    return axios({
        url: '/novelStrategy/getBookListDistribution',
        method: 'get',
        params: query
    })
}
// 添加图书
export function listBookAdd(query) {
    return axios({
        url: '/novelStrategy/addDistributionBook',
        method: 'post',
        data: query
    })
}
// 一级分类
export function firstcate(query) {
    return axios({
        url: '/novelStrategy/getFirstCategoryList',
        method: 'post',
        params: query
    })
}
// 二级分类
export function secondcate(query) {
    return axios({
        url: '/novelStrategy/getSecondCategoryList',
        method: 'post',
        params: query
    })
}